import React from 'react';
import { BellIcon, SendIcon, CalendarIcon, UsersIcon, SmartphoneIcon, CheckCircleIcon } from 'lucide-react';
export function NotificationModule({
  role
}: {
  role: string;
}) {
  const history = [{
    id: 1,
    title: 'New Feature: Skydd Bundles',
    type: 'Push & In-App',
    segment: 'All Users',
    sentAt: '2026-03-15 10:00 AM',
    status: 'Delivered',
    reach: '45,892'
  }, {
    id: 2,
    title: 'Complete your KYC',
    type: 'Push Only',
    segment: 'Tier 1 Users',
    sentAt: '2026-03-14 09:00 AM',
    status: 'Delivered',
    reach: '12,405'
  }, {
    id: 3,
    title: 'AutoGuard Renewal Reminder',
    type: 'Automated',
    segment: 'Expiring Policies',
    sentAt: '2026-03-14 08:00 AM',
    status: 'Delivered',
    reach: '142'
  }];
  return <div className="space-y-6" data-id="element-423">
      <div className="flex justify-between items-center" data-id="element-424">
        <div data-id="element-425">
          <h2 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-426">
            Notification Management
          </h2>
          <p className="text-sm text-gray-500" data-id="element-427">
            Send targeted push and in-app messages to users.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-428">
        {/* Compose Notification */}
        <div className="lg:col-span-2 bg-white rounded-3xl border border-gray-100 shadow-sm p-6" data-id="element-429">
          <h3 className="font-bold text-[#0D3B3B] text-lg mb-6 flex items-center gap-2" data-id="element-430">
            <SendIcon className="w-5 h-5 text-[#2BA89D]" data-id="element-431" /> Compose Message
          </h3>

          <div className="space-y-5" data-id="element-432">
            <div data-id="element-433">
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-434">
                Message Title
              </label>
              <input type="text" placeholder="e.g. Special Offer on AutoGuard" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#0D3B3B]" data-id="element-435" />
            </div>

            <div data-id="element-436">
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-437">
                Message Body
              </label>
              <textarea rows={4} placeholder="Type your message here..." className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm font-medium text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#0D3B3B] resize-none" data-id="element-438"></textarea>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-439">
              <div data-id="element-440">
                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-441">
                  Target Segment
                </label>
                <div className="relative" data-id="element-442">
                  <UsersIcon className="w-5 h-5 text-gray-400 absolute left-4 top-1/2 -translate-y-1/2" data-id="element-443" />
                  <select className="w-full pl-12 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#0D3B3B] appearance-none" data-id="element-444">
                    <option data-id="element-445">All Users</option>
                    <option data-id="element-446">Tier 1 Users (Pending KYC)</option>
                    <option data-id="element-447">Active Policyholders</option>
                    <option data-id="element-448">Users with Wallet Balance &gt; 0</option>
                  </select>
                </div>
              </div>
              <div data-id="element-449">
                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-450">
                  Delivery Method
                </label>
                <div className="relative" data-id="element-451">
                  <SmartphoneIcon className="w-5 h-5 text-gray-400 absolute left-4 top-1/2 -translate-y-1/2" data-id="element-452" />
                  <select className="w-full pl-12 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#0D3B3B] appearance-none" data-id="element-453">
                    <option data-id="element-454">Push Notification + In-App</option>
                    <option data-id="element-455">Push Notification Only</option>
                    <option data-id="element-456">In-App Message Only</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="pt-4 border-t border-gray-100 flex justify-between items-center" data-id="element-457">
              <button className="text-sm font-bold text-gray-500 hover:text-[#0D3B3B] flex items-center gap-2 transition-colors" data-id="element-458">
                <CalendarIcon className="w-4 h-4" data-id="element-459" /> Schedule for later
              </button>
              <button className="bg-[#0D3B3B] text-white px-6 py-3 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-[#092D2D] transition-colors shadow-lg shadow-emerald-900/20" data-id="element-460">
                <SendIcon className="w-4 h-4" data-id="element-461" /> Send Now
              </button>
            </div>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="lg:col-span-1 space-y-6" data-id="element-462">
          <div className="bg-gradient-to-br from-[#0D3B3B] to-[#1a5c5c] rounded-3xl p-6 text-white shadow-xl shadow-[#0D3B3B]/20 relative overflow-hidden" data-id="element-463">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full blur-3xl -mr-10 -mt-10 pointer-events-none" data-id="element-464" />
            <div className="relative z-10" data-id="element-465">
              <p className="text-white/60 text-xs font-bold uppercase tracking-wider mb-1" data-id="element-466">
                Total Reach
              </p>
              <h3 className="text-3xl font-bold mb-4" data-id="element-467">45,892 Users</h3>
              <div className="space-y-2" data-id="element-468">
                <div className="flex justify-between text-sm" data-id="element-469">
                  <span className="text-white/60" data-id="element-470">Push Enabled</span>
                  <span className="font-bold text-emerald-400" data-id="element-471">85%</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-472">
                  <span className="text-white/60" data-id="element-473">Avg Open Rate</span>
                  <span className="font-bold text-emerald-400" data-id="element-474">42%</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-6" data-id="element-475">
            <h4 className="font-bold text-[#0D3B3B] mb-4" data-id="element-476">
              Automated Triggers
            </h4>
            <div className="space-y-3" data-id="element-477">
              {['Payment Receipts', 'Certificate Uploads', 'Claim Status Updates', 'KYC Verification'].map((trigger, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-478">
                  <CheckCircleIcon className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-479" />
                  <span className="text-sm font-medium text-gray-600" data-id="element-480">
                    {trigger}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      {/* History Table */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-481">
        <div className="px-6 py-5 border-b border-gray-100" data-id="element-482">
          <h3 className="font-bold text-[#0D3B3B]" data-id="element-483">Notification History</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-484">
          <table className="w-full text-left" data-id="element-485">
            <thead data-id="element-486">
              <tr className="bg-gray-50/50 text-xs uppercase tracking-wider text-gray-500 font-semibold" data-id="element-487">
                <th className="px-6 py-4" data-id="element-488">Message</th>
                <th className="px-6 py-4" data-id="element-489">Type & Segment</th>
                <th className="px-6 py-4" data-id="element-490">Sent At</th>
                <th className="px-6 py-4" data-id="element-491">Reach</th>
                <th className="px-6 py-4" data-id="element-492">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-493">
              {history.map(item => <tr key={item.id} className="hover:bg-gray-50" data-id="element-494">
                  <td className="px-6 py-4 text-sm font-bold text-[#0D3B3B]" data-id="element-495">
                    {item.title}
                  </td>
                  <td className="px-6 py-4" data-id="element-496">
                    <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-497">
                      {item.type}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-498">{item.segment}</div>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600" data-id="element-499">
                    {item.sentAt}
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-[#0D3B3B]" data-id="element-500">
                    {item.reach}
                  </td>
                  <td className="px-6 py-4" data-id="element-501">
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-100 text-emerald-700" data-id="element-502">
                      <CheckCircleIcon className="w-3.5 h-3.5" data-id="element-503" /> {item.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}